// Libs
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Box, Grid2, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
// Components, Layouts, Pages
import { Loading } from '~/components/common';
import {
  AddOnProductDetail,
  DocumentProductDetail,
  InfoProductDetail,
  PhotoProductDetail,
  ProductVariantDetail,
} from '~/components/module/inventory';
// Others
import { useAppDispatch } from '~/utils/redux/hooks';
import { getDetailInventory } from '~/thunks/inventory/inventoryThunk';
import { TypeDetailInventoryEnum } from '~/utils/enum/common';
import { IInventoryDetail, IParamDetailInventory } from '~/utils/interface/inventory';
import { inventoryActions, selectIsRefreshDetailInventory } from '~/thunks/inventory/inventorySlice';
// Styles, images, icons
import styles from './ProductDetailTab.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const ProductDetailTab = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const dispatch = useAppDispatch();
  const { id: inventoryId } = useParams();
  //#endregion Declare Hook

  //#region Selector
  const isRefreshDetailInventory = useSelector(selectIsRefreshDetailInventory);
  //#endregion Selector

  //#region Declare State
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [detailProduct, setDetailProduct] = useState<IInventoryDetail>();
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    if (!inventoryId) return;

    const params: IParamDetailInventory = {
      inventoryId: inventoryId,
      type: TypeDetailInventoryEnum.OVERVIEW,
    };

    handleGetDetailInventory(params);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inventoryId]);

  useEffect(() => {
    if (!isRefreshDetailInventory || !inventoryId) return;

    const params: IParamDetailInventory = {
      inventoryId: inventoryId,
      type: TypeDetailInventoryEnum.OVERVIEW,
    };

    handleGetDetailInventory(params);

    dispatch(inventoryActions.setRefreshInventoryDetail(false));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRefreshDetailInventory]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleGetDetailInventory = (params: IParamDetailInventory) => {
    setIsLoading(true);

    dispatch(getDetailInventory(params))
      .unwrap()
      .then((res) => {
        const { data } = res;
        if (!data) return;

        setDetailProduct(data as IInventoryDetail);
      })
      .catch((err) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };
  //#endregion Handle Function

  return (
    <Stack id='productDetailTabComponent' className={cx('container')} gap={8}>
      <InfoProductDetail detailProduct={detailProduct} />

      <Box className={cx('viewLine')} />

      <Grid2 container spacing={8}>
        <Grid2 size={6}>
          <PhotoProductDetail detailProduct={detailProduct} />
        </Grid2>

        <Grid2 size={6}>
          <DocumentProductDetail detailProduct={detailProduct} />
        </Grid2>
      </Grid2>

      {!detailProduct?.isAddOn && (
        <>
          <Box className={cx('viewLine')} />

          <AddOnProductDetail detailProduct={detailProduct} />

          <ProductVariantDetail detailProduct={detailProduct} />
        </>
      )}

      {isLoading && <Loading />}
    </Stack>
  );
};

export default ProductDetailTab;
